import styled from "styled-components";

export const InnerPageLayoutStyle1 = styled.div`
  display: block;
  background: #0B0F1B;
  height: 100%;
  overflow: hidden;
  padding-top: 64px; // Space for the fixed header
  
  #page-content1 {
    background: ${(props) => props.theme.background.page1};
  }
  #page-content2 {
    background: ${(props) => props.theme.background.page2};
  }
  .userNameSidebar{
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    
  width: calc(100% - 100px);
  
}
  .page-content {
    position:relative;
    background: #0B0F1B;
  }

  &.no-spotify-padding {
    padding-top: 0px !important;

    @media (max-width: 768px) {
      padding-top: 0px !important;
    }
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .page-content {
    flex: 1;
    margin-left: 230px;
    width: calc(100vw - 230px);    
@media (max-width: 1500px) {
width: calc(100vw - 230px);  
}

    @media (max-width: 768px) {
      padding: 20px 0px;
      margin-left: 0;
      width: 100vw;
    }
  }
`;
